import React, { useEffect, useState } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import { dataLocation, dataUser } from './Helpers/util';
import $ from 'jquery';
import { toast } from 'react-toastify';
import Sidebar from './Layout/Sidebar';
import { Layout } from 'antd';
import axiosInstance from '../utils/axiosInstance';
import CustomHeader from './Layout/Header';
import SwCheckbox from './Common/FormComponent/SwCheckbox';
import SwOffCanvas from './Common/SwOffCanvas/SwOffCanvas';
import SwButton from './Common/SwButtons/SwButtons';
import SwMultiSelect from './Common/SwMultiSelect/SwMultiSelect';
import AntDTable from './Common/AntDTable/AntDTable';

const DeviceConfiguration = () => {
  const [showUserAccessModal, setShowUserAccessModal] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [devices, setDevices] = useState([]);
  const [locations, setLocations] = useState([]);
  const [userInfo, setUserInfo] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [sortDirection, setSortDirection] = useState('asc');
  const [sortColumn, setSortColumn] = useState(null);
  const [deviceUsers, setDeviceUsers] = useState([]);
  const [isChanged, setIsChanged] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [deviceLocation, setDeviceLocation] = useState([]);

  const openVisitorExportModal = () => setShowUserAccessModal(true);
  const closeVisitorExportModal = () => setShowUserAccessModal(false);

  const userDataLocal = dataUser();
  var UserObj = JSON.parse(userDataLocal);
  const userDataLocal1 = dataLocation();
  var LocationObj = JSON.parse(userDataLocal1);

  const toggleCollapsed = () => {
    setCollapsed(prevState => !prevState);
  };
  const fetchLocationsBySpoc = () => {
    const authToken = JSON.parse(localStorage.getItem('headData'));
    const headers = {
      Authorization: authToken?.spintlyToken,
      'Content-Type': 'application/json',
    };
    axios
      .get(`${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`, {
        params: { spoc: UserObj?.rec_id, client: UserObj?.company_id }, // Replace with dynamic data
        headers,
      })
      .then(res => {
        if (res.data.status === 'success') {
          const formattedLocations = res?.data?.data?.map(location => ({
            label: location.location_name,
            value: location.rec_id,
          }));
          setLocations(formattedLocations);
        }
      })
      .catch(err => console.log('Error fetching locations:', err));
  };

  const fetchAllUsersByLocation = () => {
    const authToken = JSON.parse(localStorage.getItem('headData'));
    const headers = {
      Authorization: authToken?.spintlyToken,
      'Content-Type': 'application/json',
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}user/member_list_by_locationv2`,

        {
          pgno: 1,
          row: 200000,
          company_id: UserObj ? UserObj.company_id : null,
          userid: UserObj ? UserObj.rec_id : null,
          location: LocationObj,
        },
        { headers },
      )
      .then(res => {
        if (res.data.status === 200) {
          const formattedUsers = res.data.data.list.map(user => ({
            label: `${user.fname} ${user.lname}`,
            value: user.rec_id,
          }));
          setUserInfo(formattedUsers);
        }
      })
      .catch(err => console.log('Error fetching users:', err));
  };

  const fetchDeviceData = async () => {
    setSpinner(true);
    try {
      const res = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }access-control/v3/api/device/fetch-device-data`,
        {
          company_id: UserObj ? UserObj.company_id : null,
          location_id: LocationObj.join(','),
        },
      );

      if (res.data.statusValue === 200) {
        setDevices(res.data.data);
      } else {
        toast.dismiss(); // Clear any existing toasts before showing a new one
        toast.error(res.data.message || 'Failed to fetch device data.');
      }
    } catch (err) {
      toast.dismiss(); // Ensure only one toast is shown
      toast.error(err.response?.data?.message || 'Something went wrong.');
    } finally {
      setSpinner(false);
    }
  };

  useEffect(() => {
    fetchLocationsBySpoc();
    fetchAllUsersByLocation();
  }, []);

  useEffect(() => {
    fetchDeviceData();
  }, []);

  const handleViewClick = device => {
    setSelectedDevice(device);
    setDeviceUsers(device.deviceForUser || []);
    setDeviceLocation(device.deviceForLocation || []);
    setShowModal(true);
  };

  const handleRadioChange = e => {
    setIsChanged(true);
    const value = e.target.value;
    setDeviceUsers(value);
    if (value === 'ALL') {
      setDeviceUsers([]);
    }
  };

  const handleUserChange = selected => {
    setIsChanged(true);

    setDeviceUsers(selected.map(user => user.value));
  };

  const handleSaveChanges = () => {
    axiosInstance
      .put(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }access-control/v3/api/device/update-device`,
        {
          deviceId: selectedDevice?._id,
          user_ids: userInfo
            .filter(user => deviceUsers.includes(user.value))
            .map(user => user.value)
            .join(','),
        },
      )
      .then(res => {
        if (res.data.statusValue === 200) {
          toast.success(res.data.message, {});
        }
       setShowUserAccessModal(false)
        fetchDeviceData();
    
      })
      .catch(err => {
        console.log('email err', err);
      });
    setIsChanged(false);
  };

  function getLocationNameById(locationData, locationId) {
    for (let i = 0; i < locationData?.length; i++) {
      if (locationData[i].value == locationId) {
        return locationData[i].label;
      }
    }
    return '';
  }

  const handleSort = columnName => {
    const sortedData = [...devices].sort((a, b) => {
      if (sortDirection === 'asc') {
        return a[columnName] > b[columnName] ? 1 : -1;
      } else {
        return a[columnName] < b[columnName] ? 1 : -1;
      }
    });

    setDevices(sortedData);
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortColumn(columnName);
  };

  const handleRemoveOption = optionToRemove => {
    setUserInfo(
      userInfo.filter(option => option.value !== optionToRemove.value),
    );
  };

  const ValueRendererUser = (selectedUser, optionUser) => {
    if (selectedUser?.length === optionUser?.length) {
      return 'All Users';
    } else if (selectedUser?.length === 1) {
      return selectedUser[0].label;
    } else {
      return selectedUser?.length > 0
        ? `${selectedUser?.length} users selected`
        : 'Select';
    }
  };

  const ValueRendererLocation = (selectedLocation, optionLocation) => {
    if (selectedLocation?.length === optionLocation?.length) {
      return 'All Locations';
    } else if (selectedLocation.length === 1) {
      return selectedLocation[0].label;
    } else {
      return selectedLocation?.length > 0
        ? `${selectedLocation?.length} locations selected`
        : 'Select';
    }
  };

  const handleCross = () => {
    setIsChanged(false);
  };

  const handleSelectionChange = selectedOptions => {
    setSelectedLocations(selectedOptions);
    setDeviceLocation(selectedOptions.map(user => user.value));
  };

const columns = [
  {
    title: 'Device Name',
    dataIndex: 'deviceName',
    key: 'deviceName',
    width: '20%',
    sorter: true,
    onHeaderCell: () => ({
      onClick: () => handleSort('deviceName'),
    }),
  },
  {
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    width: '25%',
    sorter: true,
    render: (_, record) =>
      getLocationNameById(locations, record?.location),
    onHeaderCell: () => ({
      onClick: () => handleSort('location'),
    }),
  },
  {
    title: 'Floor',
    dataIndex: 'floor',
    key: 'floor',
    width: '10%',
    sorter: true,
    onHeaderCell: () => ({
      onClick: () => handleSort('floor'),
    }),
  },
  {
    title: 'User Selection',
    key: 'userSelection',
    width: '25%',
    sorter: true,
    render: (_, record) =>
      record?.deviceForUser?.length === 0 ? 'All' : 'Specific',
    onHeaderCell: () => ({
      onClick: () => handleSort('userSelection'),
    }),
  },
  {
    title: 'Action',
    key: 'action',
    width: '25%',
    render: (_, record) => (
      <SwButton
        variant="dark-outline"
        className="SwBadge"
        size="sm"
        onClick={() => {
          handleViewClick(record);
          setShowUserAccessModal(true);
        }}
      >
        View
      </SwButton>
    ),
  },
];


const tableData = devices?.map(device => ({
  ...device,
  key: device.id || device._id,
}));

  

  return (
    <>
      <Layout>
        <Sidebar collapsed={collapsed} />
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

        <Layout
          className={
            collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'
          }
        >
          <div className="PageContent">
            <div className="row mb-3">
              <div className="col-md-12">
                <div className="row align-items-end justify-content-between">
                  <div className="col-md-6">
                    <div className="SwHeading">
                      <h2>User Access Management</h2>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="mainAllTable">
                    <AntDTable
                      columns={columns}
                      dataSource={tableData}
                      loading={spinner}
                      pagination={false}
                      size='small'
                      rowKey="key"
                    />
</div>

                  </div>
                </div>

                <SwOffCanvas
                  show={showUserAccessModal}
                  onClose={closeVisitorExportModal}
                  title="User Access Management"
                  placement="end"
                  backdrop="static"
                  keyboard={false}
                  footer={
                    <div className="OffCanvasFooter_Btns">
                      <SwButton
                        variant="dark-outline"
                        onClick={closeVisitorExportModal}
                      >
                        Close
                      </SwButton>
                      <SwButton
                        variant="primary"
                        onClick={handleSaveChanges}
                      >
                        Submit
                      </SwButton>
                    </div>
                  }
                >
          
                    {selectedDevice && (
                      <>
                        <p>
                          <strong>Device Name:</strong>{' '}
                          {selectedDevice.deviceName}
                        </p>
                        <p>
                          <strong>Floor:</strong> {selectedDevice.floor}
                        </p>
                        <p>
                          <strong>Locations:</strong>{' '}
                          {getLocationNameById(
                            locations,
                            selectedDevice?.location,
                          )}
                        </p>

                        <p>
                          <strong>User Selection:</strong>{' '}
                          {selectedDevice.userSelection}
                        </p>
                        
                        <div className='SwFormGroup'>
                          <SwCheckbox
                            type="radio"
                            name="modal-userSelection"
                            id='modal-userSelection-All'
                            label="ALL"
                            value="ALL"
                            checked={deviceUsers?.length === 0}
                            onChange={handleRadioChange}
                            inline
                          />

                          <SwCheckbox
                            type="radio"
                            name="modal-userSelection"
                            id='modal-userSelection-specific'
                            label="Specific Users"
                            value="specific"
                            checked={deviceUsers?.length > 0}
                            onChange={handleRadioChange}
                            inline
                          />
                        </div>
                        
                        {deviceUsers?.length > 0 && (
                          <div className='SwFormGroup mb-0'>
                            <div className="Device_conf_Multiselect">
                              <SwMultiSelect
                                options={userInfo}
                                value={userInfo.filter(user =>
                                  deviceUsers.includes(user.value)
                                )}
                                onChange={handleUserChange}
                                labelledBy="Select Users"
                                placeholder="Select Users"
                                hasSelectAll={false}
                                valueRenderer={ValueRendererUser}
                              />
                            </div>

                          </div>
                        )}

                   
                      </>
                    )}
                    {/* Badges for Selected Users */}
                    <div className="SelectedCategoriesStrip mb-2">
                      {deviceUsers?.length > 0 &&
                        userInfo.map(
                          option =>
                            deviceUsers.includes(option.value) && (
                              <div
                                className="SelectedCategories"
                                key={option.value}
                              >
                                <div className="SelectedCategoriesName">
                                  {option.label}
                                </div>
                                <div
                                  onClick={() => handleRemoveOption(option)}
                                  className="SelectedCategories_Deselect"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="8"
                                    height="8"
                                    viewBox="0 0 8 8"
                                    fill="none"
                                  >
                                    <path
                                      d="M1.59999 7.33329L0.666656 6.39995L3.06666 3.99995L0.666656 1.61662L1.59999 0.683289L3.99999 3.08329L6.38332 0.683289L7.31666 1.61662L4.91666 3.99995L7.31666 6.39995L6.38332 7.33329L3.99999 4.93329L1.59999 7.33329Z"
                                      fill="#1C1B1F"
                                    />
                                  </svg>
                                </div>
                              </div>
                            ),
                        )}
                    </div>


                    <div className='SwFormGroup'>
                      <label class="SwFormLabel"><strong>Filtered Location</strong></label>
                    
                      <SwMultiSelect
                        options={locations}
                        value={locations.filter(loc =>
                          deviceLocation.includes(loc.value)
                        )}
                        onChange={handleSelectionChange}
                        labelledBy="Select"
                        placeholder="Select"
                        valueRenderer={ValueRendererLocation}
                      />
                    </div>
                    
          
                </SwOffCanvas>
              </div>
            </div>
          </div>
        </Layout>
      </Layout>
    </>
  );
};

export default DeviceConfiguration;
